export default __webpack_public_path__ + "static/media/github.b40b1c03.svg";